import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mergeRefs } from '@/helpers/mergeRefs';
import { useEvent } from '@/hooks/use-event';
import clsx from 'clsx';
import * as React from 'react';
import Icon from '../Icon';
const MediaModal = React.forwardRef(({ children, className, ...otherProps }, forwardedRef) => {
    const dialogRef = React.useRef(null);
    useEvent('click', (event) => {
        const element = dialogRef.current;
        const wasMouse = event.offsetX !== 0 || event.offsetY !== 0;
        const rect = element.getBoundingClientRect();
        const isInsideDialog = rect.top <= event.clientY &&
            event.clientY <= rect.top + rect.height &&
            rect.left <= event.clientX &&
            event.clientX <= rect.left + rect.width;
        if (!isInsideDialog && wasMouse) {
            dialogRef.current?.close();
            event.stopPropagation();
        }
    }, dialogRef.current);
    return (_jsxs("dialog", { onKeyDown: (event) => {
            event.stopPropagation();
        }, ...otherProps, ref: mergeRefs(forwardedRef, dialogRef), className: clsx('fixed mx-auto aspect-video w-[90vw] max-w-none overflow-visible bg-transparent backdrop:bg-black/60 lg:w-[75vw]', className), children: [_jsx("div", { className: "h-full w-full", children: children }), _jsxs("button", { className: clsx('absolute -right-1 -top-3 flex items-center p-1 text-s-body-regular font-semibold text-white outline-none', 'hover:underline', 'focus:underline'), onClick: (event) => {
                    event.preventDefault();
                    dialogRef.current?.close();
                }, children: [_jsx(Icon, { className: "h-1.5 w-1.5", variant: "close" }), _jsx("span", { children: "Close" })] })] }));
});
export default MediaModal;
